import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('TaskSearchHit')
  .extend('Uuid')
  .attr('type', 'task')
  .attr('status');

Factory.define('TaskSearchHitWithDefaults')
  .extend('TaskSearchHit')
  .attr('id', 'task-123')
  .attr('customer', { id: 'customerId-123', name: 'Javiera' })
  .attr('assignee', { agent: 'Agent Smith', group: 'Support' })
  .attr('matchingText', 'tengo una tarea')
  .attr('status', 'OPEN')
  .attr('createdAt', '2017-01-11T00:00:00Z')
  .attr('updatedAt', '2017-01-12T00:00:00Z')
  .attr('dueAt', '2017-01-13T00:00:00Z');
